import { useEffect, useMemo, useState } from "react";
import { useOutletContext, useParams, useLocation } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import ActuView from "./ActuView.js";
import { getPaginedMatchDetail } from "../../../../api/index.js";
import { GET_MATCH_DETAILS } from "../../../../constants/actionTypes.js";

const ActuResolver = () => {

    const { actu } = useParams();
    const dispatch = useDispatch()

    const {live, getIdActuFromActuName} = useOutletContext();

    // Récupérer les query params (ex: ?tags=123,456)
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // Récupérer les tags du query param (?tags=123,456)
  const tags = queryParams.get("tags")?.split(",") || []; // Convertir en tableau d'IDs ou un tableau vide

    const idActu = useMemo(() => {
      return getIdActuFromActuName(actu)

    }, [getIdActuFromActuName, actu])

    const actuDetail = useSelector((state) => state.live.actualitesDetails && state.live.actualitesDetails[0]);

    /*useEffect(() => {
      if(!idActu)
        return
        
        const fetchMatchDetail = async () => {
          try {
            const response = await getMatchDetail(idMatch);
            dispatch({ type: GET_MATCH_DETAILS, payload: response.data})
              
          } catch (error) {
            console.error(error);
          }
        };
    
        fetchMatchDetail();
      }, [dispatch, idActu]);*/

      const loadMore = async () => {

        try {
          const response = await getPaginedMatchDetail(actuDetail.idActu, actuDetail.pagination, tags)
          dispatch({ type: GET_MATCH_DETAILS, payload: response.data})
            
        } catch (error) {
          console.error(error);
        }
      }

    if (!actuDetail) {
        return <CircularProgress />;
    }

    return <ActuView actu={actuDetail} loadMore={loadMore} />
    //return <MatchPreview match={matchDetail} />
}

export default ActuResolver